import { Component, EventEmitter, inject, Output, ViewEncapsulation } from '@angular/core';
import { TabsModule } from 'primeng/tabs';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { AvailableBatchesComponent } from '../available-batches/available-batches.component';
import { AcceptedBatchesComponent } from '../accepted-batches/accepted-batches.component';
import { CompletedBatchesComponent } from '../completed-batches/completed-batches.component';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageModule } from 'primeng/message';

@Component({
    selector: 'app-batches-tab',
    standalone: true,
    imports: [
        TabsModule,
        ButtonModule,
        CommonModule,
        MessageModule
    ],
    templateUrl: './batches-tab.component.html',
    styleUrl: './batches-tab.component.scss',
    host: {
        'class': 'app-batches-tab'
    },
    encapsulation: ViewEncapsulation.None
})
export class BatchesTabComponent {
  firebaseFirestoreService = inject(FirebaseFirestoreService)
  @Output() switchAppMode = new EventEmitter();
  tabs = [
    { title: 'Available', value: 0, content: AvailableBatchesComponent, icon: 'pi pi-shopping-bag' },
    { title: 'Accepted', value: 1, content: AcceptedBatchesComponent, icon: 'pi pi-check' },
    { title: 'Completed', value: 2, content: CompletedBatchesComponent, icon: 'pi pi-check-circle' },
  ];
  selectedTab = this.tabs[0];
  activatedRoute = inject(ActivatedRoute);
  router = inject(Router);
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.selectedTab = this.tabs.find(tab => tab.value+'' === params['subTab']) || this.selectedTab;
    });
  }

  onTabChange(tab: typeof this.tabs[0]) {
    this.selectedTab = tab;
    this.router.navigate([], { queryParams: undefined });
  }



  // onOpenOrdersCollectionChange() {
  //   this.firebaseFirestoreService.openOrdersCollectionSnapshot((snapshot: QuerySnapshot) => {
  //     snapshot.docChanges().forEach((change) => {
  //       if (change.type === "added") {
  //           console.log("New order has been added");
  //       }
  //       if (change.type === "modified") {
  //           console.log("Modified city: ", change.doc.data());
  //       }
  //       if (change.type === "removed") {
  //           console.log("Removed city: ", change.doc.data());
  //       }
  //     });
  //   })
  // }
} 